<template>
  <section class="serviceCenter pt-6 pb-18 bg-white">
    <div>
      <div v-if="!topPage" class="fixed bottom-4 right-4 cursor-pointer hidden md:block" @click.prevent="scrollToTop">
        <ArrowUpCircleIcon
          class="h-5 md:h-7 lg:h-7 w-5 md:w-7 lg:w-7 inline-block text-talternative-color cursor-pointer"
          aria-hidden="true"
        />
      </div>

      <div class="mx-auto w-10/12">
        <div class="grid auto-rows-auto">
          <h1 class="font-bold text-xxl flex text-talternative-color mt-0">Service en contact</h1>
          <h2 class="mb-4 font-bold text-xl flex text-talternative-color">Waarmee kunnen we u helpen</h2>
        </div>
        <div class="grid grid-rows lg:grid-cols-2 gap-4">
          <div
            v-for="(serviceItem, index) in serviceCenterDetails.informationBlock.informationTypes"
            :key="index"
            class="card shadow rounded border border-balternative-color flex flex-col justify-between"
          >
            <div class="flex flex-cols-2">
              <div class="justify-self-start ml-4 mt-1 lg:mt-0">
                <QuestionMarkCircleIcon
                  v-if="serviceItem.type === 'Question'"
                  class="h-5 md:h-7 lg:h-7 w-5 md:w-7 lg:w-7 inline-block text-talternative-color cursor-pointer my-4 mr-2"
                  aria-hidden="true"
                />
                <PlayCircleIcon
                  v-if="serviceItem.type === 'Video'"
                  class="h-5 md:h-7 lg:h-7 w-5 md:w-7 lg:w-7 inline-block text-talternative-color cursor-pointer my-4 mr-2"
                  aria-hidden="true"
                />

                <PhoneIcon
                  v-if="serviceItem.type === 'Contact'"
                  class="h-5 md:h-7 lg:h-7 w-5 md:w-7 lg:w-7 inline-block text-talternative-color cursor-pointer my-4 mr-2"
                  aria-hidden="true"
                />
                <EnvelopeIcon
                  v-if="serviceItem.type === 'Message'"
                  class="h-5 md:h-7 lg:h-7 w-5 md:w-7 lg:w-7 inline-block text-talternative-color cursor-pointer my-4 mr-2"
                  aria-hidden="true"
                />
              </div>
              <div class="">
                <h3 class="my-4 font-bold text-xl mr-2 text-talternative-color">{{ serviceItem.header }}</h3>
                <p class="pr-8 text-tdefault-color">{{ serviceItem.text }}</p>
              </div>
            </div>
            <div class="flex justify-end my-4 mr-4">
              <button
                @click.prevent="$router.push('#' + serviceItem.type)"
                class="flex justify-center py-2 px-2 md:px-4 border border-primary-color shadow-sm text-xs md:text-sm lg:text-sm font-medium text-primary-color bg-white rounded-full hover:bg-primary-default/50 items-center"
              >
                <span class="font-bold"> {{ serviceItem.buttonText }}</span>
                <ArrowRightIcon class="h-5 w-5 flex-shrink-0 ml-2 text-primary-default" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
        <div class="grid auto-rows-auto mt-4 gap-4 pb-32">
          <div class="shadow bg-white rounded border broder-bdefault" v-if="siteCode" id="Question">
            <h1 class="py-4 px-6 font-bold text-xl flex text-talternative-color bg-balternative-color my-0">
              Veelgestelde vragen
            </h1>
            <faqs />
          </div>
          <div id="Video" class="shadow bg-white rounded border broder-bdefault">
            <h1 class="py-4 px-6 font-bold text-xl flex text-talternative-color bg-balternative-color my-0">
              Instructies en handleidingen
            </h1>
            <div class="px-6 pt-2 pb-6 text-tdefault-color">
              <h2 class="py-2 font-bold">Instructies voorschrijfportaal</h2>
              <p class="py-2">
                Klik hieronder op de verschillende linkjes om instructie flows te starten voor de verschillende
                onderdelen van het voorschrijfportaal
              </p>
              <ul class="list-disc list-inside">
                <li class="py-2 font-bold">
                  <a
                    href="https://voorschrijver.mediq.nl/?userflow=1209d7df-679b-4229-97ac-d845b0b34d33"
                    target="_blank"
                  >
                    <span class="underline">Instructie startpagina voorschrijfportaal </span>
                  </a>
                </li>
                <li class="py-2 font-bold">
                  <a
                    href="https://voorschrijver.mediq.nl/patientdashboard?userflow=4a2ea7b0-7a9d-432c-af26-1d313421fed4"
                    target="_blank"
                  >
                    <span class="underline"> Instructie patiëntdashboard voorschrijfportaal </span>
                  </a>
                </li>
                <li class="py-2 font-bold">
                  <a
                    href="https://voorschrijver.mediq.nl/?userflow=6f98686d-554e-4e88-b4d9-96d39f7b61a6"
                    target="_blank"
                  >
                    <span class="underline"> Instructie aanvullen van eigen voorraad </span>
                  </a>
                </li>
              </ul>
              <h2 class="py-2 font-bold">Informatie infuus therapieën</h2>
              <p class="py-2">
                Wilt u meer weten over het gebruik van de infuuspompen die u bij Mediq kan aanvragen? We hebben
                instructievideo's ontwikkeld voor de infuuspompen CADD Solis, <br />
                Medcaptain en Bodyguard. In deze instructievideo's wordt stap voor stap aan u de belangrijkste
                handelingen uitgelegd.
              </p>
              <ul class="list-disc list-inside">
                <li class="py-2 font-bold">
                  <a
                    href="https://eur01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fmediq.flowsparks.com%2FLogin%2Fmediq%2FExternalContentAccess%3Flogin%3DN2RiZmFiNDAtMzg4Yi00YmM2LTgxMDAtYWM4MmRhYmIyZjQxOjExMDM1MTo0MzcxZDU3Yy1jNjQ0LTQ5Y2ItODJlNC00YTE1YTZmZDcyNjc%253d%26Lang%3Dnl&amp;data=05%7C02%7Colaf.donders%40flowsparks.com%7C64616465e39a445046ae08dbffd80e52%7C603cc6d965b4492dbe8995d5071203ce%7C1%7C0%7C638385075671049505%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C3000%7C%7C%7C&amp;sdata=rczCBe8r3Ds6Fs0LaAT9G%2BC%2B6S%2Fa2anjtUILZ20PJ9k%3D&amp;reserved=0\"
                    target="_blank"
                  >
                    <span class="underline">Bekijk hier de pompen instructie video's</span>
                  </a>
                </li>
                <li class="py-2 font-bold">
                  <a
                    href="https://infuus.mediq.nl/attachments/0496V1-Infuus-Overzicht-aanvraagform-A4-Cert.pdf"
                    target="_blank"
                  >
                    <span class="underline">Overzicht beschikbare aanvraagformulieren Infuustherapie</span>
                  </a>
                </li>
                <li class="py-2 font-bold">
                  <a
                    href="https://infuus.mediq.nl/attachments/Werkwijzer_Infuus_PatientoverdragenV4.pdf"
                    target="_blank"
                  >
                    <span class="underline"> Wegwijzer patiënt overdragen Infuustherapie </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div id="Contact" class="shadow bg-white rounded border broder-bdefault">
            <contact-details />
          </div>
          <div id="Message" class="shadow bg-white rounded border broder-bdefault">
            <contact />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Contact from '@/components/sections/contact/Contact';
import ContactDetails from '@/components/sections/contact/ContactDetails';
import faqs from '@/components/sections/serviceCenter/faqs.vue';
import { useStore } from 'vuex';
import { computed, onUnmounted, onMounted, ref } from 'vue';
import {
  ArrowUpCircleIcon,
  PhoneIcon,
  EnvelopeIcon,
  PlayCircleIcon,
  QuestionMarkCircleIcon,
  ArrowRightIcon
} from '@heroicons/vue/20/solid';

export default {
  name: 'ServiceCenter',
  components: {
    faqs,
    Contact,
    ContactDetails,
    PhoneIcon,
    EnvelopeIcon,
    PlayCircleIcon,
    QuestionMarkCircleIcon,
    ArrowUpCircleIcon,
    ArrowRightIcon
  },
  setup() {
    const store = useStore();
    const siteCode = computed(() => store.getters['navigation/getSiteCode']);
    const topPage = ref(false);
    const serviceCenterDetails = {
      informationBlock: {
        informationTypes: [
          {
            header: 'Ik heb een vraag',
            text: 'We hebben veel vragen en antwoorden voor u verzameld in onze hulprubriek',
            type: 'Question',
            buttonText: 'Bekijk veelgestelde vragen'
          },
          {
            header: 'Instructievideo en handleidingen voor het Mediq voorschrijfsysteem',
            text: 'Deze video laat u de belangrijkste handelingen zien, zodat u snel en efficient patienten kunt zoeken en aanmelden, bestellingen kunt plaatsen en machtigingen kunt afgeven.',
            type: 'Video',
            buttonText: 'Bekijk instructievideo'
          },
          {
            header: 'Liever telefonisch contact?',
            text: 'Staat uw vraag niet in onze hulprubriek? Wij staan graag voor u klaar',
            type: 'Contact',
            buttonText: 'Bel ons'
          },
          {
            header: 'Stuur ons een bericht',
            text: 'Stel uw vraag via het contactformulier',
            type: 'Message',
            buttonText: 'Stuur bericht'
          }
        ]
      }
    };

    const topVisible = () => {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      return scrollY === 0;
    };

    const scrollToTop = () => {
      window.scrollTo(0, 0);
    };

    onMounted(() => {
      window.addEventListener('scroll', () => {
        topPage.value = topVisible();
      });
    });

    onUnmounted(() => {
      store.commit('patient/setPatientGegevens', {});
    });

    return {
      topVisible,
      scrollToTop,
      topPage,
      serviceCenterDetails,
      siteCode
    };
  }
};
</script>
